<template>
    <tile class="invoices" link="block-invoices">
        <tile-title class="invoices__header" icon="credit-card" slot="tileHeader">
            Решения о блокировке расчётных счетов
        </tile-title>
        <div class="invoices__content" slot="tileContent">
            <update-button
                v-if="!captcha.isCaptcha" 
                class="mb-15"
                :isLoading="isUpdating" 
                :success="Number(status) === 1"
                :clickHandler="updateInvoices"
            >
                <span v-if="!isUpdating" slot="default">Обновить информацию о действующих решениях</span>
                <span v-if="isUpdating" slot="default">Информация обновляется. Ожидайте или попробуйте обновить страницу позже</span>
                <span slot="success">Информация о действующих решениях актуальна на {{dateParser(actualDate)}}</span>
            </update-button>
            <block-invoices-captcha 
                class="mb-15" 
                v-if="captcha && captcha.isCaptcha" 
                :companyCodesObj="companyCodesObj" 
                :token="captcha.token" 
                :img="captcha.img" 
            />
            <template v-if="auth && !errorMessage">
                <block-invoices-table class="mb-15" :list="actualList.slice(0,10)" :actualDate="actualDate" />
                <block-invoices-table 
                    class="mb-15" 
                    v-if="archiveList.length" 
                    :list="archiveList.slice(0,10)" 
                    :actualDate="actualDate" 
                    archived 
                />
                <block-invoices-history class="mb-15" v-if="historyList.length" :list="historyList.slice(0,5)" />
                <block-invoices-modal 
                    class="show-on-print"
                    v-show="isModal"
                    @close="hideModal"
                    :actualDate="actualDate"
                    :actualList="actualList"
                    :archiveList="archiveList"
                    :historyList="historyList.slice(0,10)"
                    :title="title"
                    :printStyle="printStyle"
                    ref="modal" 
                />
            </template>
            <span class="invoices__error" v-if="auth && errorMessage">{{errorMessage}}</span>
            <demo-message v-if="!auth" />
        </div>
        <div :class="{ end: !auth || !isButtonShow }" class="invoices__footer" slot="tileFooter">
            <tile-button v-if="auth && isButtonShow" @click.native="showModal">
                Все решения <span v-if="invoicesList && invoicesList.length">({{invoicesList.length}})</span>
            </tile-button>
            <tile-print-pdf
                :html="htmlForPrint"
                :printStyle="printStyle"
                :title="title"
                filename="blockInvoices" 
            />
        </div>
    </tile>
</template>

<script>
import tile from '@/components/ui/tile/tile.vue'
import tileTitle from '@/components/ui/tileTitle/tileTitle.vue'
import tilePrintPdf from '@/components/ui/tilePrintPdf/tilePrintPdf.vue'
import updateButton from '@/components/ui/updateButton/updateButton.vue'
import tileButton from '@/components/ui/tileButton/tileButton.vue'
import demoMessage from '@/components/ui/demoMessage/demoMessage.vue'
import blockInvoicesTable from '@/components/card/blockInvoices/blockInvoicesTable.vue'
import blockInvoicesHistory from '@/components/card/blockInvoices/blockInvoicesHistory.vue'
import blockInvoicesModal from '@/components/card/blockInvoices/blockInvoicesModal.vue'
import blockInvoicesCaptcha from '@/components/card/blockInvoices/blockInvoicesCaptcha.vue'

export default {
    components: {
        tile,
        tileTitle,
        tilePrintPdf,
        updateButton,
        tileButton,
        demoMessage,
        blockInvoicesTable,
        blockInvoicesHistory,
        blockInvoicesModal,
        blockInvoicesCaptcha
    },
    data() {
        return {
            isModal: false,
            htmlForPrint: '',
            printStyle: `
                .print-main-title {
                width: 100%;
                max-width: 960px;
                border-bottom: 1px solid #4b6365;
                color: #4b6365;
                font-size: 25px;
                margin: 0 auto;
                text-align: center;
                margin-bottom: 15px;
                margin-top: 20px;
            }
                .show-on-print { display: block !important; }
                table.invoices-table { border-collapse: collapse; }
                table.invoices-table thead tr th, td.grey-cell { background: #ddddde; }
                table.invoices-table tr th, table.invoices-table tr td {
                    padding: 10px; 
                    font-size: 14px; 
                    text-align: 
                    center; 
                    border: 1px solid #77787B; 
                }
                .invoices-table__title { font-size: 20px; font-weight: 700; margin: 20px 0; text-align: left; display: block; }
                tr.empty-invoices td { border: none !important; font-size: 16px !imoprtant; padding: 0 !important; }
                h2#print-main-title { color: #4b6365; font-size: 25px; }
                tr.empty-invoices td { width: 250px; text-align: left !important; }
            `
        }
    },
    computed: {
        ogrn() { return this.$store.state.card?.company?.ogrn },
        inn() { return this.$store.state.card?.company?.inn },
        status() { return this.$store.state.card?.invoices?.updating?.status },
        isUpdating() { return this.$store.state.card?.invoices?.updating?.isUpdating },
        actualDate() { return this.$store.state.card?.invoices?.updating?.actualDate },
        actualList() { return this.$store.getters['card/invoices/actualList'] },
        archiveList() { return this.$store.getters['card/invoices/archiveList'] },
        historyList() { return this.$store.state.card?.invoices?.historyList },
        invoicesList() { return this.$store.state.card?.invoices?.invoicesList },
        errorMessage() { return this.$store.state.card?.invoices?.errorMessage },
        captcha() { return this.$store.state.card?.invoices?.captcha },
        companyName() { return this.$store.state.card?.company?.name_short || this.$store.state.card?.company?.name_full },
        title() { return `Решения о блокировке расчётных счетов | ${this.companyName}` },
        companyCodesObj() { return { inn: this.inn, ogrn: this.ogrn } },
        isButtonShow() { return (this.invoicesList && this.invoicesList.length) || (this.historyList && this.historyList.length > 5) }
    },
    methods: {
        updateInvoices() {
            this.$store.dispatch('card/invoices/updateInvoices', this.companyCodesObj)
            $('#tiles').trigger('resize') 
        },
        getInfo() { this.$store.dispatch('card/invoices/getInfo', this.companyCodesObj) },
        getHistoryInfo() { this.$store.dispatch('card/invoices/getHistoryInfo', this.companyCodesObj) },
        async initTile() {
            await this.getInfo()
            await this.getHistoryInfo()
        },
        showModal() { this.isModal = true },
        hideModal() { this.isModal = false }
    },
    watch: {
        status() { $('#tiles').trigger('resize') },
        actualDate() {
            this.$nextTick(() => {
                this.htmlForPrint = this.$refs.modal?.$refs?.htmlContent?.outerHTML || ''
            })
        }
    },
    mounted() {
        if(this.inn) {
            this.initTile()
            .finally(() => {
                $('#tiles').trigger('resize')
                setTimeout(() => {
                    this.htmlForPrint = this.$refs.modal?.$refs?.htmlContent?.outerHTML || ''
                }, 2000)
            })
        } else {
            $('#block-invoices-tile').hide()
            $('#tiles').trigger('resize')
        }
    }
}
</script>

<style lang="sass" scoped>
@import 'styles/global-variables'

.invoices
    .mb-15
        margin-bottom: 15px
    &__footer
        @include flex-between
    .end
        justify-content: flex-end
</style>

